import FormConfig from "../formConfig.js";
import {fun_PostAction, fun_PostActionJson} from "@/api/index";
import { deepCopy } from "@/utils/validate.js";
// 引入包内容组件
import Package from "./components/index.vue";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        stepName: null, // 流程名称
        pathName: null, // 流程编码
        region: null, // 所属区管
        processStepList: null, // 流程步骤
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        stepName: null, // 流程名称
        pathName: null, // 流程编码
        region: null, // 所属区管
        processStepList: null, // 流程步骤
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 操作标志
      controllerFlg: this.$route.query.type,
    };
  },
  // 注册组件
  components: {
    Package,
  },
  // 模板编译完成
  mounted() {
    // 数据id
    this.form.id = this.$route.query.id;
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
      // 清空表单按钮
      this.$refs.Package.btnList = [];
    } 
    // 修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }  
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 加载中
      this.fun_Loading();
      // 请求，获取结果集
      fun_PostAction("/processStep/detail", {
        id: this.form.id, // 主键
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 关闭加载框
        this.fullLoading.close();
        // 判断请求是否成功
        if (result) {
          // 数据回显
          for (let key in this.form) {
            // 存在值
            if (data.processStep[key]) {
              // 赋值
              this.$set(this.form, key, data.processStep[key]);
            }
          }
          // 流程步骤
          this.$refs.Package.tableData = data.processStepList;
        }
      }).catch(err => {
        // 关闭加载框
        this.fullLoading.close();
        // 打印异常
        console.log(err);
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 保存修改
     * @param e
     */
    fun_InsUpd() {
      /// 去掉收尾空格
      for (const key in this.form) {
        // 有值
        if (this.form[key] && typeof this.form[key] === "string"){
          // 去掉空格
          this.form[key] = this.form[key].trim();
        }
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果监管流程节点为空
          if (this.$refs.Package.tableData.length == 0){
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("请至少添加一条流程步骤！");
            return false;
          }
          // 数据拷贝
          this.form.processStepList = deepCopy(this.$refs.Package.tableData);
          // 序号必须从1开始
          let sort = 1;
          // 定义缺失的序号
          let array = [];
          // 流程步骤校验，必须从1开始，中间不可间断
          for (var i = 0; i < this.form.processStepList.length;) {
            // 序号相差超过1
            if (this.form.processStepList[i].processSort - sort >= 1) {
              // 保存缺失序号
              array.push(sort);
              // 序号递增
              sort++;
            } else {
              // 序号递增
              sort++;
              i++;
            }
          }
          // 数组不为空
          if (array.length > 0) {
            // 转为字符串
            let arrayStr = array.join("、");
            // 提示信息
            this.$message.error("流程序号" + arrayStr + "缺失，请修改后再保存！");
            return;
          }

          // 提交的方法
          this.fun_Submit();
        } else {
          // 错误提示
          this.$message.error("输入内容存在错误，请根据提示完善内容！");
          return false;
        }
      });
    },
    /**
     * 提交
     * @author shuhua
     */
    fun_Submit() {
      // 弹出询问confirm
      this.$confirm("确定进行保存操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        try {
          // 加载中
          this.fun_Loading();
          // 请求
          fun_PostActionJson("/processStep/saveOrUpdate", {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const {
              result,
              data,
              msg
            } = res.data;
            // 关闭加载框
            this.fullLoading.close();
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } catch (e) {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("操作失败！" + e);
          // 关闭加载框
          this.fullLoading.close();
        }
      });
      
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val :"加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
  }
};
